import React from "react";
import { DatasetSelectorOption } from "./ui/dataset-selector";
import { ListSelectorRow } from "./ui/list-table";

/**
 * Reusable warehouse tab bar.
 * Ensures Main Warehouse is always first. Accepts the sorted `warehouses` array
 * from AuthContext (which is already sorted by backend) and highlights the
 * active tab.
 */
export default function WarehouseTabs({ warehouses, active, onChange, showAll = false, counts = {}, testidPrefix = "wh-tab", className = "" }) {
  const items = [
    ...(showAll ? [{ id: "__all__", code: "ALL", name: "All Warehouses" }] : []),
    ...warehouses,
  ];

  const warehouseAccentPalette = [
    "coral",
    "sage",
    "powder-blue",
    "peach",
    "teal",
    "lavender",
  ];

  const displayLabelFor = (warehouse) => {
    const label = `${warehouse.code || ""} ${warehouse.name || ""}`.toLowerCase();
    if (label.includes("main")) return "JAKARTA";
    if (label.includes("surabaya")) return "SURABAYA";
    if (label.includes("bali")) return "BALI";
    return warehouse.name;
  };

  const accentFor = (warehouse, index) => {
    const label = `${warehouse.code || ""} ${warehouse.name || ""}`.toLowerCase();
    if (warehouse.id === "__all__") return "neutral";
    if (label.includes("main") || label.includes("jakarta")) return "coral";
    if (label.includes("surabaya")) return "sage";
    if (label.includes("bali")) return "powder-blue";
    return warehouseAccentPalette[index % warehouseAccentPalette.length];
  };

  return (
    <ListSelectorRow className={className} aria-label="Warehouse selector" data-testid={`${testidPrefix}-bar`}>
      {items.map((w, index) => {
        const isActive = active === w.id;
        const count = counts[w.id];
        return (
          <DatasetSelectorOption
            key={w.id}
            onClick={() => onChange(w.id)}
            selected={isActive}
            accent={accentFor(w, index)}
            count={count}
            data-testid={`${testidPrefix}-${w.code}`}
          >
            {displayLabelFor(w)}
          </DatasetSelectorOption>
        );
      })}
    </ListSelectorRow>
  );
}
